import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  noindex?: boolean;
}

export function SEO({
  title = 'B2B CSV - AI-Powered Business Data Export | Lead Generation Tool',
  description = 'Find and export B2B business data across the United States. AI-powered search with CSV export for lead generation and sales prospecting. Get verified business contacts, phone numbers, emails, and social media profiles.',
  canonical,
  noindex = false
}: SEOProps) {
  const fullCanonical = canonical ? `https://b2bcsv.com${canonical}` : undefined;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {fullCanonical && <link rel="canonical" href={fullCanonical} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
